import { TextInput, type TextInputProps } from "@mantine/core";
import { useState } from "react";

interface TextValueCellProps {
  value: string | null;
  rightSection?: TextInputProps["rightSection"];
  rightSectionWidth?: TextInputProps["rightSectionWidth"];
  onChange: (value: string) => void;
}

function TextValueCell({
  value,
  rightSection,
  rightSectionWidth,
  onChange
}: TextValueCellProps) {
  const [localValue, setLocalValue] = useState<string>(value ?? "");

  function handleChange(newValue: string) {
    setLocalValue(newValue);
  }

  function handleBlurInput() {
    if (localValue !== "") {
      onChange(localValue);
    }
  }

  return (
    <TextInput
      className="text-value-cell"
      data-testid="text-value-cell"
      rightSection={rightSection}
      rightSectionWidth={rightSectionWidth}
      value={localValue}
      onBlur={handleBlurInput}
      onChange={(event) => {
        const newValue = event.currentTarget.value;
        handleChange(newValue);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleBlurInput();
        }
      }}
    />
  );
}

export { TextValueCell, TextValueCellProps };
